import type { JobDetail } from '@/features/jobs/types/job-detail'
import { apiClient } from '@/lib/api/api-client'

export const apiGetJob = (id: number | string) =>
  apiClient<JobDetail>(`/api/v1/jobs/${id}`)
